/**
 * filterOption 적용한 list 반환
 * @param list
 * @param filterOption
 * @returns {*}
 */
export const getListWithFilterOption = (list, filterOption) => {
  return list
    .filter((item) => (filterOption.id === null ? true : Number(filterOption.id) === item.id))
    .filter((item) => (filterOption.status === null ? true : filterOption.status === item.status))
    .filter((item) => (filterOption.isExhibit === null ? true : filterOption.isExhibit === item.isExhibit))
    .filter((item) => (filterOption.name === null ? true : !!item.name.match(filterOption.name)));
};

/**
 * sortOption 적용한 list 반환
 * @param list
 * @param sortOption
 * @returns {*}
 */
export const getListWithSortOption = (list, sortOption) => {
  if (sortOption.length === 0) return list;

  const { id, desc } = sortOption[0];
  return list.sort((a, b) => {
    const condition = desc ? a[id] < b[id] : a[id] > b[id];
    return condition ? 1 : -1;
  });
};
